import { APICONFIG } from '@config/api.config';
import { IQueryResponse } from '@services/api';
import { APIService } from '@services/api/common-services';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { AdoptedContractorDetails } from '.';

export const useContractorDetailQuery = (
	id: number,
	path: string,
	options?: Partial<UseQueryOptions<AdoptedContractorDetails>>
): IQueryResponse<AdoptedContractorDetails> => {
	const fetchAdoptedContractorDetailsData = async (): Promise<AdoptedContractorDetails> => {
		const url = `${APICONFIG.ADOPTED_CONTRACTOR_DETAILS}/${id}`;
		return await APIService.getData<AdoptedContractorDetails>(url);
	};

	const fetchAllEnduserDetailsData = async (): Promise<AdoptedContractorDetails> => {
		const url = `${APICONFIG.ALL_ENDUSER_CONTRACTOR_DETAILS}/${id}`;
		return await APIService.getData<AdoptedContractorDetails>(url);
	};

	const { data, error, isLoading, isPending, isFetching, refetch } = useQuery({
		queryKey: ['adoptedContractorDetails', id],
		queryFn: path === '/all' ? fetchAllEnduserDetailsData : fetchAdoptedContractorDetailsData,
		refetchOnWindowFocus: false,
		enabled: !!id,
		...options,
	});

	return {
		data,
		error,
		isLoading,
		isPending,
		isFetching,
		refetch,
	};
};
